import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import { casinoIdStatus as PlayerStatus } from '../../api/PlayerInfoConstants';
import Screens from '../../screens';
import QueryParamsProxy from '../../utils/queryParamProxy';
import routeParamConstants, { ShopTypes } from '../../utils/routeParamConstants';
import { TooltipTypes } from '../../utils/tooltipConstants';
import { getText, TEXT_KEY } from '../../utils/localization';
import Logger from '../../lib/analytics/logger';
import NotificationContext from '../../context/NotificationContext';
import rewardCenterMiddleware from '../../screens/RewardCenter/utils/middleware';
import useFeatureFlags from '../../hooks/useFeatureFlags';
import { FE_TIER_INFO_TOOLTIP } from '../../utils/featureFlags/constants';
import { handleNewActiveGameRoom } from '../../screens/Home/utils/helper';
var Tier = /*#__PURE__*/function (_Component) {
  function Tier() {
    var _useFeatureFlags;
    var _this;
    _classCallCheck(this, Tier);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Tier, [].concat(args));
    _this.hasFeature = (_useFeatureFlags = useFeatureFlags()) === null || _useFeatureFlags === void 0 ? void 0 : _useFeatureFlags.hasFeature;
    _this.tierInfoTooltipFeature = _this.hasFeature(FE_TIER_INFO_TOOLTIP);
    _this._buyClickHandler = function () {
      Logger.setActionTrigger('topBar');
      QueryParamsProxy.setQueryParams(_defineProperty(_defineProperty({}, routeParamConstants.PARAM_MODAL, Screens.Shop), routeParamConstants.PARAM_SHOP_TYPE, ShopTypes.COINS));
    };
    _this.handleClick = function () {
      var _this$props = _this.props,
        loyaltyCardComingSoon = _this$props.loyaltyCardComingSoon,
        isAccountLinked = _this$props.isAccountLinked,
        casinoIdStatus = _this$props.casinoIdStatus,
        _this$props$activeCon = _this$props.activeConsumables,
        _this$props$activeCon2 = _this$props$activeCon === void 0 ? {} : _this$props$activeCon,
        vip_room_access = _this$props$activeCon2.vip_room_access,
        navigation = _this$props.navigation;
      if (loyaltyCardComingSoon) return;

      // account is not linked.
      if (isAccountLinked === 'no') {
        QueryParamsProxy.setQueryParams(_defineProperty({}, routeParamConstants.PARAM_MODAL, Screens.LinkAccount));
        return;
      }

      // is digitally verified and no vip access (str)
      if (casinoIdStatus === PlayerStatus.DIGITALLY_VERIFIED && !vip_room_access) {
        QueryParamsProxy.setQueryParams(_defineProperty(_defineProperty({}, routeParamConstants.PARAM_MODAL, Screens.Shop), routeParamConstants.PARAM_SHOP_TYPE, ShopTypes.VIP));
        return;
      }

      // linked account
      if (!_this.tierInfoTooltipFeature) rewardCenterMiddleware({
        navigation: navigation,
        notificationContext: _this.context,
        openProfile: true
      });
    };
    _this.tooltipClickHandler = function () {
      var _this$props2 = _this.props,
        navigation = _this$props2.navigation,
        isAccountLinked = _this$props2.isAccountLinked,
        casinoIdStatus = _this$props2.casinoIdStatus;
      if (isAccountLinked !== 'yes') return;
      if (casinoIdStatus === PlayerStatus.PHYSICALLY_VERIFIED) _this._buyClickHandler();else handleNewActiveGameRoom(navigation, Screens.VIP);
    };
    _this.tooltipAttributes = function () {
      var _this$props3 = _this.props,
        memberLevel = _this$props3.memberLevel,
        casinoIdStatus = _this$props3.casinoIdStatus,
        isAccountLinked = _this$props3.isAccountLinked,
        activeConsumables = _this$props3.activeConsumables;
      if (isAccountLinked === 'yes') {
        if (casinoIdStatus === PlayerStatus.DIGITALLY_VERIFIED && activeConsumables.vip_room_access) {
          return {
            title: "".concat(getText(TEXT_KEY.ALREADY_HAVE_A), " ").concat(getText(TEXT_KEY.VIP), " ").concat(getText(TEXT_KEY.PASS)),
            buttonLabel: getText(TEXT_KEY.PLAY_BUTTON)
          };
        }
        if (casinoIdStatus === PlayerStatus.PHYSICALLY_VERIFIED) {
          return memberLevel ? {
            title: getText(TEXT_KEY.GET_TIER_POINTS),
            buttonLabel: getText(TEXT_KEY.BUY_NOW)
          } : {
            title: getText(TEXT_KEY.FEATURE_CURRENTLY_NOT_AVAILABLE)
          };
        }
      }
      return {
        title: null,
        buttonLabel: null
      };
    };
    return _this;
  }
  _inherits(Tier, _Component);
  return _createClass(Tier, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        memberLevel = _this$props4.memberLevel,
        isAccountLinked = _this$props4.isAccountLinked,
        casinoIdStatus = _this$props4.casinoIdStatus,
        activeConsumables = _this$props4.activeConsumables,
        assetsUrls = _this$props4.assetsUrls,
        linkCardAssets = _this$props4.linkCardAssets,
        loyaltyCardComingSoon = _this$props4.loyaltyCardComingSoon;
      var changeTooltipType = function changeTooltipType() {
        if (loyaltyCardComingSoon) _this2.props.changeTooltipType(_this2.props.tooltipType === TooltipTypes.TIER_COMING_SOON ? null : TooltipTypes.TIER_COMING_SOON);else _this2.props.changeTooltipType(_this2.props.tooltipType === TooltipTypes.TIER ? null : TooltipTypes.TIER);
      };
      var _this$tooltipAttribut = this.tooltipAttributes(),
        tooltipTitle = _this$tooltipAttribut.title,
        tooltipButtonLabel = _this$tooltipAttribut.buttonLabel;
      return this.props.render({
        hasVipAccess: activeConsumables && activeConsumables.vip_room_access,
        digitallyVerified: casinoIdStatus === PlayerStatus.DIGITALLY_VERIFIED,
        starDataUnavailable: isAccountLinked === 'yes' && casinoIdStatus === PlayerStatus.PHYSICALLY_VERIFIED && !memberLevel,
        clickHandler: this.handleClick,
        tooltipClickHandler: this.tooltipClickHandler,
        memberLevel: memberLevel,
        isAccountLinked: isAccountLinked,
        tooltipTitle: tooltipTitle,
        tooltipButtonLabel: tooltipButtonLabel,
        changeTooltipType: changeTooltipType,
        linkCardAssets: linkCardAssets,
        assetsUrls: assetsUrls,
        tierInfoTooltipFeature: this.tierInfoTooltipFeature,
        tooltipType: this.props.tooltipType
      });
    }
  }]);
}(Component);
Tier.contextType = NotificationContext;
export { Tier as default };